import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';

import { Table } from '../../../../components/table';
import { DetailsModal } from '../../../../components/modal';

import { getColumns } from './table/getColumns';

const defaultSorted = { dataField: 'dateAndCenter', order: 'desc' };

function SummariesTable(props){
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    const [modalMode, setModalMode] = useState(null);
    const [selectedAppointment, setSelectedAppointment] = useState(null);

    const { appointments, refreshData, switches } = props;

    const handleShowModal = useCallback((mode, appointment) => {
        if(mounted.current){
            setModalMode(mode);
            setSelectedAppointment(appointment);
        }
    }, [mounted]);
    const onSubmitCallback = useCallback((changes = false) => {
        if(mounted.current){
            setModalMode(null);
            setSelectedAppointment(null);
            if(changes) refreshData();
        }
    }, [mounted, refreshData]);

    const columns = useMemo(() => getColumns(handleShowModal, switches), [handleShowModal, switches]);

    return (
        <div>
            {modalMode &&
                <DetailsModal
                    selectedAppointment={selectedAppointment}
                    onSubmitCallback={onSubmitCallback}
                />
            }
            
            <Table
                tableName="summaries"
                data={appointments}
                columns={columns}
                sizePerPageInitial={10}
                defaultSorted={defaultSorted}
                emptyMessage="No reports were found"
            />
        </div>
    );
}

export default connect(null, {

})(SummariesTable);